"use strict";
/* tslint:disable */
var TComboNoCombinationSPSlipMode = (function () {
    "use strict";
    var api = {};
    api.buildHeader = function () {
        return "";
    };
    return api;
}());
window.TComboNoCombinationSPSlipMode = TComboNoCombinationSPSlipMode;
//# sourceMappingURL=TComboNoCombinationSPSlipMode.js.map